import { State, TabDisplayInterface, User, UserRole, UserType } from '@wam/shared';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { switchMap, takeUntil } from 'rxjs/operators';
import { authenticationSelectors } from '@wam/authentication';
import { intersection, isEmpty } from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class ActivitiesTabDisplayService implements TabDisplayInterface, OnDestroy {
  private store = inject<Store<State>>(Store);

  private destroyed$ = new Subject<void>();

  isFirst(): Observable<boolean> {
    return of(false);
  }

  shouldShow(): Observable<boolean> {
    const isPlaylistAdmin = (roles: UserRole[]) => {
      return !isEmpty(
        intersection(roles, [
          UserRole.INTERNAL_ADMIN,
          UserRole.CURRICULUM_ADMIN,
          UserRole.ACCOUNT_ADMIN,
          UserRole.PLAYLIST_ADMIN,
        ]),
      );
    };

    return this.store.pipe(
      select(authenticationSelectors.getCurrentUser),
      switchMap((user: User) => {
        if (!user) {
          return of(false);
        }
        switch (user.type) {
          case UserType.TEACHER:
            return of(true);
          case UserType.ADMIN:
            return of(isPlaylistAdmin(user.roles));
          default:
            return of(false);
        }
      }),
      takeUntil(this.destroyed$),
    );
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
